<template>
  <div class="page-wrap">
    <div class="page-content">
      <a-card :title="$t('page_console_notification_rule_business')" style="width: 350px;margin-right:10px;">
        <div class="actions" slot="extra">
          <span class="" @click="onAddRule">{{$t('page_console_notification_rule_add')}}</span>
            <span @click="onEditRule" :class="{disabled:!currentId}">{{$t('page_console_notification_rule_edit')}}</span>
            <span class="del" @click="onDelRule" :class="{disabled:!currentId}">{{$t('page_console_notification_rule_delete')}}</span>
        </div>
        <div>
          <div v-for="(item,index) in ruleList" :key="index" class="rule-item" :class="{active:currentId == item.id}"
          @click="changeRule(item)"
          >
            <span>{{item.ruleName}}</span>
            <!--工作记录状态变化不展示工位-->
            <a-popover v-if="item.dictKey!=='work-record-status-change'"
                    placement="bottomLeft" trigger="click" overlayClassName="devGroup">
              <span style="padding:0 13px;"><a-icon type="caret-down" /></span>
              <template slot="content">
               <a-tree
                  :selectable="false"
                  :tree-data="item.groupList"
                  :replace-fields="replaceFields"
                />
              </template>
            </a-popover>
          </div>
        </div>
      </a-card>
      <a-card :title="ruleName?`${$t('page_console_notification_rule_notification_rule')}[${ruleName}]`:`${$t('page_console_notification_rule_notification_rule')}`" style="flex:1;">
        <div class="actions" slot="extra">
          <span class="" @click="onAddConfig">{{$t('page_console_notification_rule_add')}}</span>
          <span :class="{disabled:selectedRowKeys.length !== 1}" @click="onEditConfig">{{$t('page_console_notification_rule_edit')}}</span>
          <span class="del" :class="{disabled:!selectedRowKeys.length}" @click="onDelConfig">{{$t('page_console_notification_rule_delete')}}</span>
        </div>
        <div>
          <ml-table
            :pagination="pagination"
            :columns="columns"
            :dataSource="list"
            bordered
            :loading="loading"
            rowKey="id"
            :canChangeColWidth="true"
            :row-selection="{width:40,fixed:true,selectedRowKeys:selectedRowKeys, onChange: onTableSelectChange}"
          >
          </ml-table>
        </div>
      </a-card>
    </div>
    <addRule :visible="addRuleShow" :isEdit="addRuleIsEdit" @cancel="addRuleCancel" @success="onUpdateRule" :id="currentId"></addRule>
    <addConfig :visible="addConfigShow" :dictKey="dictKey" :ruleId="currentId" :id="selectedRowKeys[0]" :isEdit="addConfigIsEdit" @cancel="addConfigCancel" @success="onUpdateConfig"></addConfig>
  </div>
</template>

<script>
 import { DataTreeNode } from '@/utils/array'
import addRule from './components/addRule';
import addConfig from './components/addConfig';
 import { cloneDeep } from 'lodash'
import { NotificationRuleBusinessServiceProxy, MessageNotificationRulesServiceProxy } from "@/service-proxies/app-v2/notify.service-proxies"
import { WorkStationGroupServiceProxy } from "@/service-proxies/app-v2/workStation.service-proxies"
const notificationRuleBusinessServiceProxy = new NotificationRuleBusinessServiceProxy();
const messageNotificationRulesServiceProxy = new MessageNotificationRulesServiceProxy();
const workStationGroupServiceProxy = new WorkStationGroupServiceProxy();

export default {
  components:{
    addRule,
    addConfig
  },
  computed: {
    columns () {
      let basic1 = [{
        title: this.$t('page_console_notification_rule_sort'),   // 顺序
        dataIndex: 'sort',
        key: 'sort',
        width: 100,
        align: 'center',
        ellipsis: true
      }
      ]
      let basic2=[
        {
          title: this.$t('page_console_notification_rule_notification_name'),   // 通知名称
          dataIndex: 'notificationNameDesc',
          key: 'notificationNameDesc',
          align: 'center',
          // width: 100,
          ellipsis: true
        }
      ]

      /*工作记录状态变化*/
      let workRecordStatus = [
        {
          title: this.$t('page_console_notification_rule_work_status') || '工作状态',   // 工作状态
          dataIndex: 'notificationNameDesc',
          key: 'notificationNameDesc',
          align: 'center',
          // width: 100,
          ellipsis: true
        }
      ]

      /*设备状态通知*/
      let deivceStatus = [{
        title: this.$t('page_console_notification_rule_first') + this.$t('page_console_notification_rule_triggering_conditions') + '(' + this.$t('minutes') + ')',   // 首次触发条件
        dataIndex: 'firstTriggerCondition',
        key: 'firstTriggerCondition',
        align: 'center',
        // width: 100,
        ellipsis: true
      }, {
        title: this.$t('page_console_notification_rule_increasing_condition') + '(' + this.$t('minutes') + ')',   // 递增条件
        dataIndex: 'incrementCondition',
        key: 'incrementCondition',
        align: 'center',
        // width: 100,
        ellipsis: true
      }, {
        title: this.$t('page_console_notification_rule_send_toplimit') + '(' + this.$t('page_console_notification_rule_times') + ')',   // 发送次数上限
        dataIndex: 'sendNumberLimit',
        key: 'sendNumberLimit',
        align: 'center',
        // width: 100,
        ellipsis: true
      }
      ]

      let basic3 = [
        {
          title: this.$t('page_console_notification_rule_notification_time_range'),   // 通知时间范围
          dataIndex: 'notificationTimeRangeDesc',
          key: 'notificationTimeRangeDesc',
          align: 'center',
          // width: 100,
          ellipsis: true,
          customRender: (text, record) => {
            if (record.notificationTimeRange == 1) {
              return text
            } else {
              return record.startTime + '~' + record.endTime
            }
          }
        }
      ]

      let basic4 = [
        {
          title: this.$t('page_console_notification_rule_isEnable'),   // 是否启用
          dataIndex: 'isEnableDesc',
          key: 'isEnableDesc',
          align: 'center',
          // width: 100,
          ellipsis: true
        }, {
          title: this.$t('page_console_notification_rule_notification_user'),   // 通知人员
          dataIndex: 'notificationUserName',
          key: 'notificationUserName',
          align: 'center',
          // width: 100,
          ellipsis: true
        }
      ]

      if (this.dictKey === 'work-record-status-change') { // 工作记录状态变化
        return [...basic1, ...workRecordStatus, ...basic4]
      } else if (this.dictKey === 'device-state-notify') {// 设备状态通知
        return [...basic1, ...basic2, ...deivceStatus, ...basic3, ...basic4]
      } else { // 工位产量超差预警
        return [...basic1, ...basic2, ...basic3, ...basic4]
      }
    }
  },
  watch:{
    currentId() {
      this.selectedRowKeys = []
    }
  },
  async created(){
    await this.getWorkStationGroup();
    await this.getRuleList();
    this.getBussinessList();
    this.pagination.onChange = (currentPage) => {
      this.pagination.current = currentPage;
      this.getBussinessList();
    };
  },
  methods:{
    // 获取工位组
    async getWorkStationGroup(){
      this.treeData = [];
      await workStationGroupServiceProxy.workStationGroupList().then(res => {
         this.workStationGroupList = res;
      })
    },
    async getRuleList () {
      await notificationRuleBusinessServiceProxy.queryNotificationRuleBusiness(1, -1).then(res => {
        let data = res.records || []
        if (data.length) {
          data.forEach(item => {
            // let groupData = []
            // let workStationGroupList = cloneDeep(this.workStationGroupList)
            // let groupIdArr = item.groupId.split(',');
            // groupData = workStationGroupList.filter(workStation => {
            //   return (groupIdArr.includes(workStation.id) || groupIdArr.includes(workStation.parentId))
            // })
            // item.groupList = DataTreeNode.arrayToTree(groupData);
            item.groupList = this.getTreeData(item)
          })
        }

        this.ruleList = data
        if (!this.currentId && this.ruleList.length) {
          this.currentId = this.ruleList[0].id
          this.ruleName = this.ruleList[0].ruleName
          this.dictKey = this.ruleList[0].dictKey
        }
      })
    },
    getTreeData (data) {
      let groupIds = [], workStationIds = []
      let workStationGroupList = cloneDeep(this.workStationGroupList)
      if (data.groupId) { // 勾选的工位组
        groupIds = data.groupId.split(',')
      }
      if (data.workstationId) { // 勾选的工位
        workStationIds = data.workstationId.split(',')
      }
      let parentIds = []
      // 返回被勾选的子节点
      let temp = workStationGroupList.filter(workStation => {
        if (workStationIds.includes(workStation.id)) {
          parentIds.push(workStation.parentId) // 本身未勾选，但包含勾选的工位的工位组
          return true
        }
      })
      groupIds = Array.from(new Set([...parentIds, groupIds]))
      // 返回需要显示的父节点
      let temp2 = workStationGroupList.filter(workStation => {
        return (groupIds.includes(workStation.id))
      })
      return DataTreeNode.arrayToTree([...temp, ...temp2])
    },
    changeRule(item){
      if(this.currentId == item.id) return;
      this.currentId = item.id;
      this.ruleName = item.ruleName;
      this.dictKey = item.dictKey;
      this.getBussinessList();
    },
    // 新增
    onAddRule(){
      this.addRuleIsEdit = false;
      this.$nextTick(() => {
        this.addRuleShow = true;
      })
    },
    // 编辑
    onEditRule(){
      if(!this.currentId){
        return;
      }
      this.addRuleIsEdit = true;
      this.$nextTick(() => {
        this.addRuleShow = true;
      })
    },
    // 删除
    onDelRule(){
      let _this = this;
      if(!this.currentId){
        return;
      }
      this.$confirm({
        title: this.$t('delete_tips')+'?',
        onOk: () => {
          notificationRuleBusinessServiceProxy.deleteNotificationRuleBusiness(_this.currentId).then(async () => {
            _this.$message.success(_this.$t('page_console_notification_rule_delete_success'));
            _this.currentId = '';
            _this.ruleName = ''
            _this.dictKey = ''
            await _this.getRuleList();
            _this.pagination.current = 1;
            _this.getBussinessList();
          })
        },
        onCancel() {
          // console.log('Cancel');
        }
      });
    },
    // 更新规则
    onUpdateRule(){
      this.addRuleShow = false;
      this.getRuleList();
    },
    // 取消新增
    addRuleCancel(){
      this.addRuleShow = false;
    },
    // 获取业务规则
    getBussinessList(){
      if(!this.currentId){
        this.pagination.total = 0;
        this.list = [];
        return
      }
      this.loading = true;
      let type = this.dictKey === 'work-record-status-change' ? 2 : 1
      messageNotificationRulesServiceProxy.queryMessageNotificationRules(this.pagination.current,this.currentId,this.pagination.pageSize, type).then(res => {
         this.loading = false;
         this.list = res.records || [];
         this.pagination.total = res.total;
      })
    },

    // 新增配置
    onAddConfig(){
      this.addConfigIsEdit = false;
      this.$nextTick(() => {
        this.addConfigShow = true;
      })
    },
    // 编辑配置
    onEditConfig(){
      if(this.selectedRowKeys.length !== 1){
        return;
      }
      this.addConfigIsEdit = true;
      this.$nextTick(() => {
        this.addConfigShow = true;
      })
    },
    // 删除
    onDelConfig(){
      let _this = this;
      if(!this.selectedRowKeys.length){
        return;
      }
      this.$confirm({
        title: this.$t('delete_tips')+'?',
        onOk() {
          messageNotificationRulesServiceProxy.deleteMessageNotificationRules(_this.selectedRowKeys).then(res => {
            _this.$message.success(_this.$t('page_console_notification_rule_delete_success'));
            _this.selectedRowKeys = [];
            _this.pagination.current = 1;
            _this.getBussinessList();
          })
        },
        onCancel() {

        }
      });
    },
    // 更新配置
    onUpdateConfig(){
      this.addConfigShow = false;
      this.getBussinessList();
    },
    // 配置新增/编辑取消
    addConfigCancel(){
      this.addConfigShow = false;
    },
    onTableSelectChange(data){
      this.selectedRowKeys = data;
      console.log('selectedRowKeys:', this.selectedRowKeys)
    }
  },
  data(){
    return{
      ruleName:'',
      dictKey:'',
      ruleList:[],
      currentId:'',
      loading:false,
      replaceFields:{
        key:'id'
      },
      workStationGroupList:[],  // 工位组
      list:[],
      selectedRowKeys:[],
      pagination: {
        size:'normal',
        total: 0,
        pageSize: 10,
        current: 1,
      },
      addRuleShow:false,
      addRuleIsEdit:false,
      addConfigShow:false,
      addConfigIsEdit:false,
      currentConfigIds:[]
    }
  }
}
</script>

<style lang="less" scoped>
.page-wrap{
  height: 100%;

}
.page-content{
  display: flex;
  .business-config{
    width: 300px;
    flex-shrink: 0;
    border: solid 1px #d1d1d1;
  }
}
.actions{
  span{
    margin-left:5px;
    padding: 0 5px;
    cursor: pointer;
    color:#3a7fbc;

    &.del{
      color:#ff0000;
    }
    &.disabled{
      color:#ccc;
      cursor:not-allowed;
    }
  }
}
/deep/ .ant-card-head{
  min-height: 42px;
  padding: 0 15px;
}
/deep/ .ant-card-head-title{
  font-size: 14px;
  padding:10px 0;
}
/deep/ .ant-card-extra{
  padding: 10px 0;
}
/deep/ .ant-card-body{
  padding: 15px;
}
.rule-item{
  padding: 3px 5px;
  margin:2px 0;
  cursor: pointer;
  &.active{
    background: #3a7fbc;
    color:#fff;
  }
}

/deep/ .ant-popover-inner-content{
  padding: 5px 5px !important;
  max-height: 350px;
  overflow: auto;
}
</style>
<style>
.devGroup .ant-popover-inner-content{
  padding: 5px 5px !important;
  max-height: 350px;
  overflow: auto;
}
</style>
